<div class="settings-page">
    <div class="content-box">

        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Rapoarte (Amenzi)</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Rapoarte (Amenzi)</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-amenzi.generate')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="generate()">
                                <i class="fa-solid fa-plus"></i>
                                Generează Raport
                            </button>
                        </div>
                    </div>

                    <div class="card-container p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) de la</mat-label>
                                        <input matInput formControlName="date_from" [matDatepicker]="dateFromPicker"
                                            readonly (focus)="dateFromPicker.open()" />
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateFromPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateFromPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) până la</mat-label>
                                        <input matInput formControlName="date_to" [matDatepicker]="dateToPicker"
                                            readonly (focus)="dateToPicker.open()" />
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateToPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateToPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) Finalizare de la</mat-label>
                                        <input matInput formControlName="date_finalized_from"
                                            [matDatepicker]="dateFinalizedFromPicker" readonly
                                            (focus)="dateFinalizedFromPicker.open()" />
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateFinalizedFromPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateFinalizedFromPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) Finalizare până la</mat-label>
                                        <input matInput formControlName="date_finalized_to"
                                            [matDatepicker]="dateFinalizedToPicker" readonly
                                            (focus)="dateFinalizedToPicker.open()" />
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateFinalizedToPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateFinalizedToPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Registru</mat-label>
                                        <mat-select formControlName="registru_id"
                                            (openedChange)="onSerieSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="seriiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredSerii.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>

                                            <mat-option *ngFor="let serie of filteredSerii" [value]="serie.id">
                                                {{ serie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Departament</mat-label>
                                        <mat-select formControlName="departament_id"
                                            (openedChange)="onCompartimentSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="compartimenteControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>

                                            <mat-option *ngFor="let compartiment of filteredCompartimente"
                                                [value]="compartiment.id">
                                                {{ compartiment.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Utilizator</mat-label>
                                        <mat-select (openedChange)="onUsersSelectClosed()" formControlName="user_id">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="usersControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredUsers.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let user of filteredUsers" [value]="user.id">
                                                {{ user.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Destinatar</mat-label>
                                        <mat-select formControlName="destinatar_id">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="destinatariControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="showDestinatariMessage" disabled>
                                                <span
                                                    *ngIf="!destinatariControl.value || destinatariControl.value.length < 2">
                                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                                </span>
                                                <span
                                                    *ngIf="isDestinatariLoading && destinatariControl.value.length >= 2">
                                                    Se caută...
                                                </span>
                                                <span
                                                    *ngIf="!isDestinatariLoading && destinatariLoadComplete && destinatari.length === 0 && destinatariControl.value && destinatariControl.value.length >= 2">
                                                    Nu s-au găsit rezultate
                                                </span>
                                            </mat-option>

                                            <mat-option *ngFor="let destinatar of destinatari" [value]="destinatar.id">
                                                {{ destinatar.denumire }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Tip Document</mat-label>
                                        <mat-select formControlName="tip_document_id"
                                            (openedChange)="onTipuriDocumenteSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="tipuriDocumenteControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredTipuriDocumente.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>

                                            <mat-option *ngFor="let tip of filteredTipuriDocumente" [value]="tip.id">
                                                {{ tip.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <div class="row w-100">
                            <div class="col d-flex justify-content-start">
                                <button (click)="toggleCard()" type="button"
                                    class="btn btn-sm btn-warning closeBtn">Închide</button>
                            </div>
                            <div class="col buttons-submit">
                                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                    Resetează
                                </button>
                                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                                    Aplică
                                </button>
                            </div>
                        </div>

                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                    </div>

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>